import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useCustomer = (restaurantId) => {
  const [card, setCard] = useState(undefined);

  const reload = useCallback(() => {
    api.get(`/restaurants/${restaurantId}/customer/me`).then((r) => setCard(r.data)).catch(() => setCard(null));
  }, [restaurantId]);

  useEffect(() => {
    reload();
  }, [reload]);

  const logout = async () => {
    await api.post(`/restaurants/${restaurantId}/customer/logout`);
    setCard(null);
  };

  return { card, setCard, reload, logout };
};
